import { render } from "./AddSpda.vue?vue&type=template&id=771dd761"
import script from "./AddSpda.vue?vue&type=script&lang=js"
export * from "./AddSpda.vue?vue&type=script&lang=js"
script.render = render

export default script